module.exports = __webpack_public_path__ + "static/media/ios.2ce3f865.png";